import styled from "styled-components";

import { Button } from "@components";

export const Filter = styled.div`
  display: inline;
`;

export const Trigger = styled.div`
  cursor: pointer;
  padding: 12px;

  &:hover {
    opacity: 0.8;
  }
`;

export const TooltipWrapper = styled.div`
  height: 0;
  width: 100%;
`;

export const FilterTooltip = styled.div`
  position: absolute;
  z-index: 2;
  left: -10px;
  right: 0;
  top: calc(100% + 1px);
  padding: 0.5rem;
  font-size: 0.9rem;
  background-color: ${({ theme }) => theme.darkestBlue};
  width: 100%;
  text-align: left;
  cursor: default;
  box-sizing: border-box;
`;

export const FilterOptionBlock = styled.div<{ hasSearch?: boolean }>`
  max-height: 250px;
  overflow-y: auto;
  padding-bottom: 8px;
  padding-top: ${({ hasSearch }) => (hasSearch ? "0" : "8px")};
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 5px 0 5px;
`;

export const NoOptions = styled.div`
  padding: 5px 8px;
`;

export const FilterOptionButton = styled(Button)`
  background-color: transparent;
  width: 100%;
  padding: 5px 8px;

  > div {
    display: block;
    text-align: left;
  }

  :hover {
    color: ${({ theme }) => theme.white};
    background-color: ${({ theme }) => theme.secondaryColor};
    opacity: 1;
  }
  &.selected {
    background-color: ${({ theme }) => theme.primaryColor};
  }
`;

export const ClearButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid;
  padding-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
`;

export const ClearButton = styled(Button)`
  background-color: transparent;
  padding: 0;
  font-size: 14px;
`;

export const SearchBox = styled.div`
  display: flex;
  gap: 5px;
  margin: 5px;
  padding-left: 10px;
  height: 31px;
  background-color: ${({ theme }) => theme.casalColor};
`;

export const SearchInput = styled.input`
  outline: none;
  border: none;
  border-radius: 2px;
  padding: 3px 10px;
  height: 100%;
  width: 100%;
  color: white;
  background-color: transparent;
  box-sizing: border-box;
  font-size: 16px;

  &::placeholder {
    color: currentColor;
    font-size: 14px;
  }
`;
